import { render, staticRenderFns } from "./SanctionSimple.vue?vue&type=template&id=51a5c8b2&"
import script from "./SanctionSimple.vue?vue&type=script&lang=js&"
export * from "./SanctionSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports